import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {FieldMap, OptionI, Primitive} from "../../../../../Types";
import {createMapFilterSchema} from "../../../../../features/init";
import {selectMapColourStylesSingle} from "../../../../filters/FilterMultiMapValue";
import {default as Select} from "react-select";

interface PropsI {
    value: string,
    onChange: (arg: Primitive, invalid?: boolean) => void,
    map: FieldMap
}

const lang = 'ua'

function RawEditMap({value, onChange, map}: PropsI) {

    let [newValue, setNewValue] = useState<OptionI | undefined>(undefined);
    let [options, setOptions] = useState<OptionI[]>([]);

    function onChangeMap(val: OptionI) {
        setNewValue(val)
        onChange(val.value)
    }

    useEffect(() => {
        let mapFilterSchema = createMapFilterSchema(map);
        let so
        if (value !== null) {
            so = mapFilterSchema.options?.find(x => x.value == value);
            if (so === undefined) {
                so = {
                    label: {
                        'ua': 'Значення не знайдено',
                        'en': 'Empty value',
                    },
                    value: undefined,
                    disabled: true
                }
                onChange(null, true)
            }

        } else {
            so = {
                label: {
                    'ua': 'Порожнє значення',
                    'en': 'Empty value',
                },
                value: null,
                disabled: true
            }
            onChange(null, true)
        }

        let initial = {
            ...so,
            label: so!.label[lang]
        } as OptionI
        let opts = mapFilterSchema.options?.map(o => ({
            ...o,
            label: o.label[lang],
        }));
        setOptions(opts || [])
        setNewValue(initial)
    }, []);

    return <Container>
        <Select
            className={'select-map'}
            value={newValue}
            onChange={(newValue) => onChangeMap(newValue)}
            closeMenuOnSelect={true}
            placeholder={"Оберіть значення"}
            options={options}
            styles={selectMapColourStylesSingle}
        />
    </Container>
}

export default RawEditMap;

const Container = styled.div`
    .select-map {
        border-radius: 0;
        color: black;
        flex-grow: 1;
    }
`

